import * as React from 'react';

import Image from 'next/future/image';
import Link from 'next/link';

import ByLine from '@/components/pages/frontpage/components/Feature/Middle/ByLine';
import type { ArticleType } from '@/types/ArticleType';
import slugify from '@core/utils/functions/slugify';
import decodeEntities from '@/utils/functions/string/decodeEntities';

type SubFeatureProps = {
    article: ArticleType;
    showImage: boolean;
};

const SubFeature = (props: SubFeatureProps) => {
    const { article, showImage } = props;
    const { excerpt, slug, primaryCategory, title, authors, publishedAtTimestamp } = article;

    return (
        <div className="justify-start items-center flex-grow gap-2 w-full">
            {showImage && (
                <Link href={`/news/${slug}`} passHref>
                    <a className="cursor-pointer">
                        <div className="hidden lg:block mb-2">
                            <Image
                                src={article.imageUrl}
                                width={280}
                                height={157.5}
                                sizes="100vw"
                                className="w-full"
                                alt="article-image"
                            />
                        </div>
                        <div className="hidden md:block lg:hidden mb-2">
                            <Image
                                src={article.imageUrl}
                                width={560}
                                height={315}
                                sizes="100vw"
                                className="object-cover w-full"
                                alt="article-image"
                            />
                        </div>
                        <div className="block md:hidden mb-2">
                            <Image
                                src={article.imageUrl}
                                width={140}
                                height={78.75}
                                sizes="100vw"
                                className="object-cover w-full"
                                alt="article-image"
                            />
                        </div>
                    </a>
                </Link>
            )}
            <div className="gap-1">
                <p className="flex gap-2 flex-grow">
                    <Link href={`/category/${slugify(decodeEntities(primaryCategory))}`} passHref>
                        <a className="text-primary text-xs uppercase">{decodeEntities(primaryCategory)}</a>
                    </Link>
                    {article.categories.includes('Sponsored') && (
                        <Link href={`/category/sponsored`} passHref>
                            <a className="text-blue-500 text-xs uppercase">Sponsored</a>
                        </Link>
                    )}
                </p>
            </div>
            <div className="mt-1 gap-2.5">
                <Link href={`/news/${slug}`}>
                    <a className="flex-grow text-lg md:text-xl xl:text-2xl font-headline hover:text-primary">{title}</a>
                </Link>
            </div>
            <div className="mt-1 gap-2.5 text-gray-500">{excerpt}</div>
            <ByLine authors={authors} publishedAtTimestamp={publishedAtTimestamp} className="mt-2 text-xs" />
        </div>
    );
};

export default SubFeature;
